export const currentLocale = 'nl'
export const extraLanguages = ["en", "de"]